import EmailAuthScreen from '../../../auth/register/confirmEmail/resendEmailAuth'
import ProfilePhotoScreen from '../../../auth/register/photo/profilePhotoScreen'
import PhoneScreen from '../../../auth/register/phone/phoneScreen'
import RiderExperienceScreen from '../screens/riderExpScreen'
import RiderResumeScreen from '../screens/riderResumeScreen'
import InsuranceScreen from '../screens/insuranceScreen' //turn off for persona
import LicenseScreen from './licenseScreen/licenseScreen'
import ProfileAddressScreen from '../screens/profileAddressScreen'
import AgeQuestionScreen from '../screens/ageQuestionScreen'
import EndorsementQuestionScreen from '../screens/endorsementQuestionScreen'
import PartnerLicenseScreen from '../screens/licenseScreen/partnerLicenseScreen'
import {
  PHONE,
  PROFILE_PHOTO,
  LICENSE,
  INSURANCE,
  RESUME,
  EXPERIENCE,
  PROFILE_ADDRESS,
  EMAIL,
  ENDORSEMENT_QUESTION,
  AGE_QUESTION,
  AGE_QUESTION_ERROR,
  PARTNER_LICENSE
} from '../main/constants'

export const SCREENS = {
  [PHONE]: {
    size: 'tiny',
    key: PHONE,
    screen_details: 'Confirm your phone number.',
    component: PhoneScreen,
    extra_props: {
      parentDescription: 'Information Wizard',
    },
  },
  [EMAIL]: {
    key: EMAIL,
    size: 'mini',
    screen_details: 'Confirm your email address.',
    component: EmailAuthScreen,
    extra_props: {
      header: 'Make sure to verify your email!',
    },
    extra_book_props: {
      buttonText: "Ok - Let's Pay and Go!",
      instructions:
        'Renters that have a verified email address are more likely to have their Rental Request approved by the motorcycle owner.',
    },
    extra_listing_props: {
      buttonText: 'Ok, thanks.',
      instructions:
        'Renters are more likely to rent from an owner with a verified email address.',
    },
  },
  [INSURANCE]: {
    key: INSURANCE,
    size: 'small',
    screen_details: 'Insurance Cards',
    component: InsuranceScreen,
  },
  [LICENSE]: {
    key: LICENSE,
    size: 'small',
    screen_details: "Driver's license",
    component: LicenseScreen,
  },
  [PROFILE_ADDRESS]: {
    key: PROFILE_ADDRESS,
    size: 'small',
    screen_details: 'Your home address',
    component: ProfileAddressScreen,
  },
  [PROFILE_PHOTO]: {
    key: PROFILE_PHOTO,
    size: 'mini',
    screen_details: 'Profile Photo',
    component: ProfilePhotoScreen,
  },
  [RESUME]: {
    key: RESUME,
    size: 'tiny',
    screen_details: 'A small description of yourself',
    component: RiderResumeScreen,
  },
  [EXPERIENCE]: {
    key: EXPERIENCE,
    size: 'tiny',
    screen_details: 'Your riding experience',
    component: RiderExperienceScreen,
  },
  [ENDORSEMENT_QUESTION]: {
    key: ENDORSEMENT_QUESTION,
    size: 'mini',
    screen_details: 'Motorcycle endorsement on license',
    component: EndorsementQuestionScreen,
  },
  [AGE_QUESTION]: {
    key: AGE_QUESTION,
    size: 'mini',
    screen_details: 'Your age',
    component: AgeQuestionScreen,
  },
  [AGE_QUESTION_ERROR]: {
    key: AGE_QUESTION_ERROR,
    size: 'medium',
    screen_details: 'Age Error'
  },
  [PARTNER_LICENSE]: {
    key: PARTNER_LICENSE,
    size: 'small',
    screen_details: "Driver's license",
    component: PartnerLicenseScreen,
  },
}
